import { Box, Paper, Tab } from "@mui/material";
import { useEffect, useState } from "react";

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Base from "../../../Base/views/Base";
import ExpenseAdminPage from "./ReviewExpenses/ExpenseAdminPage";
import ExpensePayoutReport from "./PayoutExpenses/Report";

const TeamExpenseLandingPage = () => {
    const [value, setValue] = useState(0);
    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Paper sx={{ borderRadius: "10px", }}>
                        {children}
                    </Paper>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Base>
            <Box sx={{ maxHeight: "87vh", overflowY: 'auto' }}>
                <Tabs 
                    value={value} 
                    onChange={handleChange} 
                    aria-label="basic tabs example" 
                    variant="scrollable"
                    orientation="horizontal"
                    allowScrollButtonsMobile={true}
                    sx={{
                        minHeight: "40px", ".MuiTab-root": { minHeight: "20px" },
                        '& .MuiTabs-indicator': {
                            width: '100%',
                            display: 'flex',
                            justifyContent: "center !important",
                        },
                    }}
                    >
                    <Tab label="Review Expenses" {...a11yProps(0)} />
                    <Tab label="Expense Reports" {...a11yProps(1)} />
                </Tabs>
                <TabPanel value={value} index={0}>
                    <ExpenseAdminPage />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <ExpensePayoutReport />
                </TabPanel>
            </Box>
        </Base>
    )
}

export default TeamExpenseLandingPage;
